export default "__VITE_ASSET__7c672c7d__"